import { HealthMetrics } from '../../types/health';
import { QuickReply } from '../../types/chat';

// Compact, focused suggestions
const suggestions: QuickReply[] = [
  {
    id: 'workout',
    text: 'Workout ready?',
    category: 'workout',
    condition: m => m.recovery > 70 && m.strain.current < 14
  },
  {
    id: 'recovery',
    text: 'Need recovery?',
    category: 'recovery',
    condition: m => m.recovery < 70 || m.strain.current > 16
  },
  {
    id: 'sleep',
    text: 'Sleep tips',
    category: 'sleep',
    condition: m => m.sleep.score < 85
  },
  {
    id: 'strain',
    text: 'Check strain',
    category: 'recovery',
    condition: m => m.strain.current > 12
  },
  {
    id: 'hrv',
    text: 'HRV status',
    category: 'recovery',
    condition: m => m.hrv.current < m.hrv.yesterday
  }
];

export function generateSuggestions(metrics: HealthMetrics): QuickReply[] {
  if (!metrics) return [];

  // Filter relevant suggestions based on current metrics
  const relevantSuggestions = suggestions.filter(
    suggestion => !suggestion.condition || suggestion.condition(metrics)
  );

  // Shuffle array
  const shuffled = [...relevantSuggestions]
    .sort(() => Math.random() - 0.5);

  // Return top 2-3 most relevant suggestions
  return shuffled.slice(0, Math.min(3, shuffled.length));
}